// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"fe4e95f4","166":"b2ffe50b","341":"ea6f3c37","517":"89bebc57","639":"f6223fee","753":"74ec1889","815":"c5686f75","818":"1d8ea9d1"}[chunkId] + ".chunk.js";
};